<template>
  <div class="filter-search-container">
    <div class="logo-section">
      <svg class="logo-icon" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2l3 3-3 3-3-3 3-3zM6 8l3 3-3 3-3-3 3-3zM18 8l3 3-3 3-3-3 3-3zM12 14l3 3-3 3-3-3 3-3z" />
      </svg>
      <span class="logo-text">{{ $t("brand") || 'Frame 25' }}</span>
    </div>

    <div class="search-wrapper">
      <input
        type="text"
        class="search-input"
        v-model="searchQuery"
        placeholder=""
      />
      <span class="search-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </span>
    </div>

    <div class="filter-section">
      <button class="filter-btn">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue'])

const searchQuery = ref(props.modelValue)

watch(() => props.modelValue, (newVal) => {
  searchQuery.value = newVal
})

watch(searchQuery, (newVal) => {
  emit('update:modelValue', newVal)
})
</script>

<style scoped>
.filter-search-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 15px;
  background-color: #f8f9fa;
  gap: 15px;
  box-sizing: border-box;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #121212;
}

.logo-icon {
  width: 24px;
  height: 24px;
}

.logo-text {
  font-size: 1.2rem;
  font-weight: 600;
  white-space: nowrap;
}

.search-wrapper {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 400px;
  margin: 0 auto;
}

.search-input {
  width: 100%;
  padding: 8px 36px 8px 16px;
  border-radius: 9999px;
  border: 1px solid #e5e7eb;
  background-color: #ffffff;
  font-size: 0.95rem;
  outline: none;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
}

.search-input:focus {
  border-color: #d1d5db;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.search-icon {
  position: absolute;
  right: 12px;
  width: 16px;
  height: 16px;
  color: #6b7280;
  pointer-events: none;
}

/* RTL Support for search icon */
html[dir="rtl"] .search-icon {
  right: auto;
  left: 12px;
}

html[dir="rtl"] .search-input {
  padding: 8px 16px 8px 36px;
}

.filter-section {
  display: flex;
  align-items: center;
}

.filter-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  color: #4b5563;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.filter-btn:hover {
  background-color: rgba(0,0,0,0.05);
}

.filter-btn svg {
  width: 20px;
  height: 20px;
}
</style>
